(() => {
  const nav = document.querySelector(".navimow-header_nav");
  nav.addEventListener("keyup", (e) => {
    if (e.code === "Escape") {
      const buttons = nav.querySelectorAll("button[aria-expanded]");
      buttons?.forEach((button) => {
        button.setAttribute("aria-expanded", "false");
      });
    }
  });

  const header = document.querySelector("header.navimow-header");

  const mobileMenuButton = document.querySelector(
    ".navimow-header_mobile-menu-button",
  );
  let isMobileMenuOpen = false;
  mobileMenuButton.addEventListener("click", () => {
    document.documentElement.style.setProperty(
      "--header-top",
      Math.round(header.parentElement.getBoundingClientRect().top) + "px",
    );
    isMobileMenuOpen = !isMobileMenuOpen;
    mobileMenuButton.setAttribute("aria-expanded", isMobileMenuOpen);
    document.documentElement.classList.toggle(
      "globalnav-noscroll",
      isMobileMenuOpen,
    );
  });

  const mediaList = window.matchMedia("(min-width: 1024px)");

  /**
   * list menu
   */
  const listDetails = document.querySelectorAll(
    ".navimow-header .header-menu-list",
  );

  listDetails.forEach((detail) => {
    const button = detail.querySelector(".header-menu-list-button");
    const detailContent = detail.querySelector(
      ".header-menu-list-content_list",
    );

    detail.style.setProperty(
      "--header-menu-list-content-height",
      `${detailContent.firstElementChild.clientHeight}px`,
    );

    const transitionReset = () => {
      detail.classList.add("header-menu-closed");
      button.setAttribute("aria-expanded", "false");
    };

    detailContent.addEventListener("transitionend", (event) => {
      if (event.target !== detailContent) return;
      if (detail.classList.contains("header-menu-open")) return;
      transitionReset();
    });

    let mouseOverTimeout = null;

    const triggerHeightTransition = (open) => {
      if (open) {
        detail.classList.add("header-menu-open");
        detail.classList.remove("header-menu-closed");
        button.setAttribute("aria-expanded", "true");
      } else {
        detail.classList.remove("header-menu-open");
        if (detailContent.clientHeight === 0) {
          transitionReset();
        }
      }
    };

    const mouseEnterHandler = () => {
      clearTimeout(mouseOverTimeout);
      mouseOverTimeout = setTimeout(() => {
        triggerHeightTransition(true);
      }, 120);
      detail.addEventListener("mouseleave", mouseLeaveHandler, { once: true });
    };

    const mouseLeaveHandler = () => {
      clearTimeout(mouseOverTimeout);
      triggerHeightTransition(false);
    };

    if (mediaList.matches) {
      detail.addEventListener("mouseenter", mouseEnterHandler);
      button.addEventListener("focus", mouseEnterHandler);
    } else {
      // mobile
      let isOpen = false;
      button.addEventListener("click", function () {
        isOpen = !isOpen;
        if (isOpen) {
          button.setAttribute("aria-expanded", isOpen);
        }
        triggerHeightTransition(isOpen);
      });
    }
  });

  /**
   * mega menu
   */

  const megaDetails = document.querySelectorAll(
    ".navimow-header .header-menu-mega",
  );

  megaDetails.forEach((detail) => {
    const button = detail.querySelector("button");
    const detailContent = detail.querySelector(
      ".header-menu-mega-content_list",
    );
    detail.style.setProperty("--header-menu-mega-content-height", `${0}px`);

    const transitionReset = () => {
      detail.classList.add("header-menu-closed");
      button.setAttribute("aria-expanded", "false");
    };

    detailContent.addEventListener("transitionend", (event) => {
      if (event.target !== detailContent) return;
      if (detail.classList.contains("header-menu-open")) return;
      transitionReset();
    });

    let mouseOverTimeout = null;

    const triggerHeightTransition = (open) => {
      if (open) {
        detail.classList.add("header-menu-open");
        detail.classList.remove("header-menu-closed");
        button.setAttribute("aria-expanded", "true");
      } else {
        detail.classList.remove("header-menu-open");
        if (detailContent.clientHeight === 0) {
          transitionReset();
        }
      }
    };

    const mouseEnterHandler = () => {
      clearTimeout(mouseOverTimeout);
      mouseOverTimeout = setTimeout(() => {
        triggerHeightTransition(true);
      }, 120);
      detail.addEventListener("mouseleave", mouseLeaveHandler, { once: true });
    };

    const mouseLeaveHandler = () => {
      clearTimeout(mouseOverTimeout);
      triggerHeightTransition(false);
    };

    const megaItemButton =
      detail.querySelectorAll(".header-menu-mega-item-button") || [];
    megaItemButton.forEach((item, index) => {
      item.dataset.idx = index;
    });

    const openMegaItemDetail = (idx) => {
      const currentButton = megaItemButton[idx];
      if (!currentButton) return;
      megaItemButton.forEach((item) => {
        item.setAttribute("aria-expanded", "false");
      });
      currentButton.setAttribute("aria-expanded", "true");

      const currentContent = currentButton.nextElementSibling;
      detail.style.setProperty(
        "--mega-item-content-height",
        `${currentContent.clientHeight}px`,
      );
      detail.style.setProperty(
        "--header-menu-mega-content-height",
        `${detailContent.firstElementChild.clientHeight}px`,
      );

      // 防止 swiper 的 bug
      const swiperNodes =
        currentButton.parentElement.querySelectorAll(".swiper");
      swiperNodes.forEach((node) => {
        const swiper = node.swiper;
        if (swiper) swiper.scrollbar.enable();
      });
    };

    function widthChangeCallback(mediaList) {
      if (mediaList.matches) {
        // tablet
        detail.addEventListener("mouseenter", mouseEnterHandler);
        button.addEventListener("focus", mouseEnterHandler);

        megaItemButton.forEach((item) => {
          let delayTimeout = null;
          item.addEventListener("mouseenter", function () {
            clearTimeout(delayTimeout);
            delayTimeout = setTimeout(() => {
              const idx = +item.dataset.idx;
              openMegaItemDetail(idx);
            }, 120);
          });
          item.addEventListener("mouseleave", function () {
            clearTimeout(delayTimeout);
          });
          item.addEventListener("focus", function () {
            const idx = +item.dataset.idx;
            openMegaItemDetail(idx);
          });
        });

        openMegaItemDetail(0);
      } else {
        // mobile
        let isOpen = false;
        button.addEventListener("click", function () {
          detail.style.setProperty(
            "--header-menu-mega-content-height",
            `${detailContent.firstElementChild.clientHeight}px`,
          );
          isOpen = !isOpen;
          triggerHeightTransition(isOpen);
        });

        megaItemButton.forEach((item) => {
          item.addEventListener("click", function () {
            const isExpanded = item.getAttribute("aria-expanded") === "true";
            const currentContent = item.nextElementSibling.querySelector(
              ".mega-item-content_inner",
            );
            item.parentElement.style.setProperty(
              "--mega-item-content-height",
              `${currentContent.clientHeight}px`,
            );
            item.setAttribute("aria-expanded", isExpanded ? "false" : "true");
            if (!isExpanded)
              detail.style.setProperty(
                "--header-menu-mega-content-height",
                `auto`,
              );
          });
          item.nextElementSibling.addEventListener(
            "transitionend",
            function (event) {
              if (event.target !== item.nextElementSibling) return;
              height = detailContent.firstElementChild.clientHeight;
              detail.style.setProperty(
                "--header-menu-mega-content-height",
                `${height}px`,
              );
            },
          );
        });
      }
    }
    widthChangeCallback(mediaList);
  });

  /**
   * multilist menu
   */

  const multilistDetails = document.querySelectorAll(
    ".navimow-header .header-menu-multilist",
  );

  multilistDetails.forEach((detail) => {
    const button = detail.querySelector(".header-menu-multilist-button");
    const detailContent = detail.querySelector(
      ".header-menu-multilist-content_list",
    );

    detail.style.setProperty(
      "--header-menu-multilist-content-height",
      `${detailContent.firstElementChild.clientHeight}px`,
    );

    const transitionReset = () => {
      detail.classList.add("header-menu-closed");
      button.setAttribute("aria-expanded", "false");
    };

    detailContent.addEventListener("transitionend", (event) => {
      if (event.target !== detailContent) return;
      if (detail.classList.contains("header-menu-open")) return;
      transitionReset();
    });

    let mouseOverTimeout = null;

    const triggerHeightTransition = (open) => {
      if (open) {
        detail.classList.add("header-menu-open");
        detail.classList.remove("header-menu-closed");
        button.setAttribute("aria-expanded", "true");
      } else {
        detail.classList.remove("header-menu-open");
        if (detailContent.clientHeight === 0) {
          transitionReset();
        }
      }
    };

    const mouseEnterHandler = () => {
      clearTimeout(mouseOverTimeout);
      mouseOverTimeout = setTimeout(() => {
        triggerHeightTransition(true);
      }, 120);
      detail.addEventListener("mouseleave", mouseLeaveHandler, { once: true });
    };

    const mouseLeaveHandler = () => {
      clearTimeout(mouseOverTimeout);
      triggerHeightTransition(false);
    };

    function widthChangeCallback(mediaList) {
      if (mediaList.matches) {
        // tablet
        detail.addEventListener("mouseenter", mouseEnterHandler);
        button.addEventListener("focus", mouseEnterHandler);
      } else {
        // mobile
        let isOpen = false;
        button.addEventListener("click", function () {
          isOpen = !isOpen;
          if (isOpen) {
            button.setAttribute("aria-expanded", isOpen);
          }
          triggerHeightTransition(isOpen);
        });
      }
    }
    widthChangeCallback(mediaList);
  });

  // track event

  const trackEvent = (data) => {
    window.dataLayer = window.dataLayer || [];
    const current_page = window.location.href;
    window.dataLayer.push({
      event: "ga4Event",
      event_name: "header-cta",
      event_parameters: {
        current_page: current_page,
        ...data,
      },
    });
  };

  const headerMenuMegaLink = document.querySelectorAll(
    ".navimow-header .header-menu-mega-link-item",
  );
  headerMenuMegaLink.forEach((link) => {
    link.addEventListener("click", (event) => {
      trackEvent({
        heading: link
          .closest(".header-menu-mega")
          .querySelector(".header-menu-mega-button").innerText,
        button_name: link.querySelector(".header-menu-mega-link-text")
          ?.innerText,
        link: link.getAttribute("href"),
      });
    });
  });

  const headerMenuMegaItemBannerLink = document.querySelectorAll(
    ".navimow-header .header-menu-mega-item-banner-link",
  );
  headerMenuMegaItemBannerLink.forEach((link) => {
    link.addEventListener("click", (event) => {
      trackEvent({
        heading: link
          .closest(".header-menu-mega")
          ?.querySelector(".header-menu-mega-button")?.innerText,
        subheading: link
          .closest(".header-menu-mega-item")
          ?.querySelector(".header-menu-mega-item-button-text")?.innerText,
        title: link?.querySelector(".header-menu-mega-item-banner-link-title")
          ?.innerText,
        button_name: "banner_image",
        link: link.getAttribute("href"),
      });
    });
  });

  const headerMenuMegaItemViewAllLink = document.querySelectorAll(
    ".navimow-header .header-menu-mega-item-view-all-link",
  );
  headerMenuMegaItemViewAllLink.forEach((link) => {
    link.addEventListener("click", (event) => {
      trackEvent({
        heading: link
          .closest(".header-menu-mega")
          ?.querySelector(".header-menu-mega-button")?.innerText,
        subheading: link
          .closest(".header-menu-mega-item")
          ?.querySelector(".header-menu-mega-item-button-text")?.innerText,
        button_name: link.innerText,
        link: link.getAttribute("href"),
      });
    });
  });

  const headerMenuMegaItemProductLink = document.querySelectorAll(
    ".navimow-header .header-menu-mega-item-product-link",
  );
  headerMenuMegaItemProductLink.forEach((link) => {
    link.addEventListener("click", (event) => {
      trackEvent({
        heading: link
          .closest(".header-menu-mega")
          ?.querySelector(".header-menu-mega-button")?.innerText,
        subheading: link
          .closest(".header-menu-mega-item")
          ?.querySelector(".header-menu-mega-item-button-text")?.innerText,
        title: link?.querySelector(".header-menu-mega-item-product-title")
          ?.innerText,
        link: link.getAttribute("href"),
      });
    });
  });

  const headerMenuListItemLink = document.querySelectorAll(
    ".navimow-header .header-menu-list-item-link",
  );
  headerMenuListItemLink.forEach((link) => {
    link.addEventListener("click", (event) => {
      trackEvent({
        heading: link
          .closest(".header-menu-multilist")
          ?.querySelector(".header-menu-multilist-button")?.innerText,
        subheading: link
          .closest(".header-menu-list-item")
          ?.querySelector(".header-menu-list-item-title")?.innerText,
        button_name: link?.innerText,
        link: link.getAttribute("href"),
      });
    });
  });

  const headerMenuListLink = document.querySelectorAll(
    ".navimow-header .header-menu-list-link",
  );
  headerMenuListLink.forEach((link) => {
    link.addEventListener("click", (event) => {
      trackEvent({
        heading: link
          .closest(".header-menu-list")
          ?.querySelector(".header-menu-list-button")?.innerText,
        button_name: link?.innerText,
        link: link.getAttribute("href"),
      });
    });
  });

  const headerMenuLink = document.querySelectorAll(
    ".navimow-header .header-menu-link",
  );
  headerMenuLink.forEach((link) => {
    link.addEventListener("click", (event) => {
      trackEvent({
        heading: "header menu link",
        button_name: link?.innerText,
        link: link.getAttribute("href"),
      });
    });
  });

})();
